export default __webpack_public_path__ + "Mask-group-4.e3db8b.svg";